import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

/**
 * "Zertifiziert und transparent" — rebuilt in the presentation's own
 * silent-luxury style.  Original PPTX slide is discarded; only the
 * background-removed GIA certificate composite floats centred on the
 * page, surrounded by generous whitespace and a soft golden glow.
 */
export default function SectionZertifiziert() {
  const { t } = useT();
  const z = t.zertifiziert || t.sicherheit;

  return (
    <SectionShell id="zertifiziert" className="relative overflow-hidden" fullBleed centerContent>
      <div className="zert-shell zert-shell--split" data-testid="zert-shell">
        <div className="zert-copy zert-copy--stacked" style={{ marginTop: 'clamp(60px, 12vh, 150px)' }}>
          <Reveal>
            <div className="overline zert-overline" data-testid="zert-overline">
              {z.overline}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <h2 className="zert-title font-display" data-testid="zert-title">
              {z.title}
            </h2>
          </Reveal>

          <Reveal delay={220}>
            <p className="zert-body font-ui" data-testid="zert-body">
              {z.body}
            </p>
          </Reveal>
        </div>

        <Reveal delay={360}>
          <div className="zert-image-stage" data-testid="zert-image-stage">
            <div className="zert-image-glow" aria-hidden="true" />
            <img
              src="/gia-zertifikat.png"
              alt="GIA Diamond Grading Report — Sample"
              loading="lazy"
              className="zert-image"
              draggable={false}
            />
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
